import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

export const priceSummaryJobQueryKeys = {
  all: ['priceSummaryJobs'] as const,
  recent: () => [...priceSummaryJobQueryKeys.all, 'recent'] as const,
};

export function useGetRecentPriceSummaryJobs({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: priceSummaryJobQueryKeys.recent(),
    queryFn: () => PriceParrotService.getPriceSummaryJobs({ limit: 50 }),
    select: (response) => response.data,
    enabled,
  });
}
